import React from 'react';

const FooterV2 = () => (
	<footer className="bg-ink/90 border-t border-gold/30 py-8">
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
			<div className="mb-4 md:mb-0">
				<span className="font-display text-xl text-gold">Sam Togun</span>
				<p className="text-gray-500 font-mono text-xs mt-2">Senior Backend Engineer &amp; Solutions Architect</p>
			</div>
			<div className="flex space-x-6">
				<a href="https://www.linkedin.com/in/oluwatobi-togun/" className="text-gray-500 hover:text-gold transition-colors"><i className="fab fa-linkedin-in text-xl"></i></a>
				<a href="https://github.com/TOGUNOLUWATOBI" className="text-gray-500 hover:text-gold transition-colors"><i className="fab fa-github text-xl"></i></a>
			</div>
		</div>
		<div className="mt-8 text-center text-gray-600 font-mono text-xs">
			&copy; {new Date().getFullYear()} Sam Togun. All rights reserved.
		</div>
	</footer>
);

export default FooterV2;
